<template>
    <div class="pageWidth fix" id="top">
        <div id="logo"><strong><a title="雅昌艺术网" target="_blank" href="//www.artron.net">雅昌艺术网</a></strong><a class="logoLink" href="/">雅昌拍卖</a></div>
        <div class="fr search" id="topSearch">
            <div id="sForm"><a target="_parent" class="sbtn" href="javascript:;" @click="gotoSo">搜索</a>
                <div class="sRadius" :style="{borderColor:hoverSearch ? 'rgba(15,130,12)' : '#D4D4D4'}">
                    <div class="class" :class="{'hover':hoverSelect}" @mouseenter="selectHover(1)" @mouseleave="selectHover(2)">
                        <div class="classVal"><b class="dropdown"></b><em id="sorts">{{className}}</em></div>
                        <ul class="classify lih" :style="{height:hoverSelect?'210px':'0px',visibility:hoverSelect ? 'visible':'hidden'}">
                            <li v-for="(item,i) in classList" :key="i" @click="clickSelect(item)">
                                {{item}}
                            </li>
                        </ul></div><input type="text" onkeypress="" id="keyword" name="keyword" class="sInput" :class="{'noBg':noBg}" v-model="sInput" @focus="selectSearch(1)" @blur="selectSearch(2)"></div></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "header",
    data(){
        return{
            classList:['资讯','拍卖','艺术品','展览','艺术家','图书','专题'],
            className:'拍卖',
            sInput:'',
            hoverSearch:false,
            hoverSelect:false,
            noBg:false
        }
    },
    methods:{
        selectHover(num){
            if(num == 1){
                this.hoverSearch = true
                this.hoverSelect = true
            }else {
                this.hoverSearch = false
                this.hoverSelect = false
            }
        },
        selectSearch(num){
            if(num == 1){
                this.hoverSearch = true
                this.noBg=true
            }else {
                this.hoverSearch = false
                if(this.sInput.trim() != ''){
                    this.noBg = true
                }else{
                    this.noBg = false
                }
            }
        },
        clickSelect(val){
            this.className = val
            this.hoverSelect = false
        },
        gotoSo(){
            let gotoUrl = '';
            switch (this.className){
                case '拍卖':
                    gotoUrl = 'https://artso.artron.net/auction/search_auction.php'
                    break
                case '画廊':
                    gotoUrl = 'https://artso.artron.net/gallery/search_gallery.php'
                    break
                case '新闻':
                    gotoUrl = 'https://artso.artron.net/news/search_newslist.php'
                    break
                case '艺术品':
                    gotoUrl = 'https://artso.artron.net/jewel/search_jewel.php'
                    break
                case '展览':
                    gotoUrl = 'https://artso.artron.net/exhibit/search_exhibition.php'
                    break
                case '艺术家':
                    gotoUrl = 'https://artso.artron.net/artist/search_artist.php'
                    break
                case '图书':
                    gotoUrl = 'https://artso.artron.net/ebook/search_book.php'
                    break
            }
            if(this.sInput.trim()){
                window.location.href = gotoUrl + '?keyword='+encodeURIComponent(this.sInput)
            }else{
                window.location.href = 'https://artso.artron.net'
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import url('../../assets/css/resetOld.scss');
.sRadius{transition: .2s border-color ease-in-out;}
.classify{transition: .2s height ease-in-out;}
.classify li:hover{background-color: #0F820C;color:#fff;}
</style>